import React from 'react'
import { PostScore } from './buttons'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'

interface Props {
  enableSelfSubmission?: boolean
}

const PostAScore = ({ enableSelfSubmission }: Props) => {
  const isLoggedIn = useSelector((state: AppState) => state.user.isLoggedIn)
  const ownProfile = useSelector((state: AppState) => state.profile.ownProfile)

  const isSelfSubmissionEnabled = enableSelfSubmission && !!ownProfile?.eligibleForSelfSubmission
  
  return isLoggedIn && isSelfSubmissionEnabled ? <PostScore /> : null
}

export default PostAScore
